import a1 from "./a1.png"
import a2 from "./a2.png"
import a3 from "./a3.png"
import a4 from "./a4.png"
// src/pages/Finishing.js
// src/pages/Finishing.js
import React from "react";
import "./Finishing.css";



const overperformers = [
  { shooterName: "Artemi Panarin", shots: 1055, xG: 55.34, goals: 104, diff: 48.66 },
  { shooterName: "Leon Draisaitl", shots: 1045, xG: 73.58, goals: 115, diff: 41.42 },
  { shooterName: "Jordan Kyrou", shots: 1146, xG: 72.46, goals: 112, diff: 39.54 },
  { shooterName: "David Pastrnak", shots: 1565, xG: 93.84, goals: 132, diff: 38.16 },
  { shooterName: "Kyle Connor", shots: 1165, xG: 85.63, goals: 123, diff: 37.37 },
  { shooterName: "Jason Robertson", shots: 1156, xG: 75.16, goals: 112, diff: 36.84 },
  { shooterName: "Jared McCann", shots: 863, xG: 52.31, goals: 82, diff: 29.69 },
  { shooterName: "Nathan MacKinnon", shots: 1611, xG: 97.83, goals: 127, diff: 29.17 },
  { shooterName: "Brayden Point", shots: 977, xG: 89.02, goals: 118, diff: 28.98 },
  { shooterName: "Tage Thompson", shots: 1088, xG: 72.35, goals: 101, diff: 28.65 }
];

const underperformers = [
  { shooterName: "Blake Coleman", shots: 1134, xG: 87.66, goals: 63, diff: -24.66 },
  { shooterName: "Pierre-Luc Dubois", shots: 901, xG: 74.81, goals: 51, diff: -23.81 },
  { shooterName: "Brendan Gallagher", shots: 844, xG: 71.27, goals: 48, diff: -23.27 },
  { shooterName: "Jordan Martinook", shots: 964, xG: 70.50, goals: 49, diff: -21.50 },
  { shooterName: "Evan Rodrigues", shots: 1053, xG: 68.91, goals: 48, diff: -20.91 },
  { shooterName: "Tomas Nosek", shots: 462, xG: 35.82, goals: 17, diff: -18.82 },
  { shooterName: "Drew O'Connor", shots: 526, xG: 45.60, goals: 27, diff: -18.60 },
  { shooterName: "William Carrier", shots: 674, xG: 61.39, goals: 43, diff: -18.39 },
  { shooterName: "Adam Lowry", shots: 747, xG: 71.11, goals: 53, diff: -18.11 },
  { shooterName: "Anthony Cirelli", shots: 795, xG: 72.59, goals: 55, diff: -17.59 }
];

const Finishing = () => {
  const maxOver = Math.max(...overperformers.map(p => p.diff));
  const maxUnder = Math.min(...underperformers.map(p => p.diff)); 

  return (
    <div className="finishing-page">
      <header className="finishing-header">
        <h1>Player Finishing Model (5v5, 2020–2024)</h1>
        <p>
          Using our shot-level ML goal probability model, we estimate expected goals (xG)
          for every shot and aggregate by player. This highlights who consistently converts 
          more (or less) than expected relative to shot quality.
        </p>

        <div className="finishing-stats">
          <span>Shots analyzed: 443,420 (5v5, non-empty net)</span>
          <span>Players with ≥ 30 shots: 1,094</span>
        </div>
      </header>

      {/* =====================================================
          TABLE: ABOVE EXPECTED
      ===================================================== */}
      <section className="finishing-section">
        <p>The purpose of this analysis is to compare actual goals scored to expected goals (xG) based on shot quality, in order to identify players who consistently finish chances better or worse than expected at 5-on-5. This isolates finishing ability from shot volume and shot location.</p>
        <h2>Top 10 Finishers Above Expected</h2>
        <p className="finishing-section-text">
          These players scored far more than the model expected based on shot quality.
          Positive finishing is driven by elite shooting skill, deception, accuracy, and release.
        </p>

        <div className="finishing-table-wrapper">
          <table className="finishing-table">
            <thead>
              <tr>
                <th>Player</th><th>Shots</th><th>xG</th><th>Goals</th><th>Goals − xG</th><th>Impact</th>
              </tr>
            </thead>
            <tbody>
              {overperformers.map(p => (
                <tr key={p.shooterName}>
                  <td>{p.shooterName}</td>
                  <td>{p.shots}</td>
                  <td>{p.xG.toFixed(1)}</td>
                  <td>{p.goals}</td>
                  <td>{p.diff.toFixed(2)}</td>
                  <td className="finishing-bar-col">
                    <div className="finishing-bar-track">
                      <div
                        className="finishing-bar finishing-bar-positive"
                        style={{ width: `${(p.diff / maxOver) * 100}%` }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* =====================================================
          TABLE: BELOW EXPECTED
      ===================================================== */}
      <section className="finishing-section">
        <h2>Top 10 Finishers Below Expected</h2>
        <p className="finishing-section-text">
          These players underperformed their expected goals despite generating good looks.
          Low finishing can reflect cold streaks, luck, shot selection, or true talent limitations.
        </p>

        <div className="finishing-table-wrapper">
          <table className="finishing-table">
            <thead>
              <tr>
                <th>Player</th><th>Shots</th><th>xG</th><th>Goals</th><th>Goals − xG</th><th>Impact</th>
              </tr>
            </thead>
            <tbody>
              {underperformers.map(p => (
                <tr key={p.shooterName}>
                  <td>{p.shooterName}</td>
                  <td>{p.shots}</td>
                  <td>{p.xG.toFixed(1)}</td>
                  <td>{p.goals}</td>
                  <td>{p.diff.toFixed(2)}</td>
                  <td className="finishing-bar-col">
                    <div className="finishing-bar-track">
                      <div
                        className="finishing-bar finishing-bar-negative"
                        style={{ width: `${Math.abs(p.diff / maxUnder) * 100 }%` }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* =====================================================
          IMAGE SECTIONS (a1–a4)
      ===================================================== */}

      <section className="finishing-section">
        <h2>Visualization: Top 20 Overperformers (Chart)</h2>
        <img src={a1} alt="Top Overperformers Chart" className="finishing-img" />
        <p className="finishing-section-text">
          This bar chart shows the players with the highest total finishing above expected.
          These shooters convert difficult chances at an elite rate over a 4-season sample.
        </p>
      </section>

      <section className="finishing-section">
        <h2>Visualization: Top 20 Underperformers (Chart)</h2>
        <img src={a2} alt="Top Underperformers Chart" className="finishing-img" />
        <p className="finishing-section-text">
          Underperformers fall below the model’s expectations despite similar shot volume.
          This often indicates a mix of cold finishing runs and poorer shooting efficiency.
        </p>
      </section>

      <section className="finishing-section">
        <h2>Scatter Plot: Goals vs Expected Goals</h2>
        <img src={a3} alt="Goals vs Expected Goals Scatter" className="finishing-img" />
        <p className="finishing-section-text">
          Each dot represents an individual player. The dashed red line is where goals = xG.
          Points above the line indicate efficient finishers; points below the line
          indicate underperformance relative to chance quality.
        </p>
      </section>

      <section className="finishing-section">
        <h2>Distribution of Finishing (Histogram)</h2>
        <img src={a4} alt="Finishing Distribution Histogram" className="finishing-img" />
        <p className="finishing-section-text">
          The distribution of Goals − xG is centered near zero but with long tails.
          This confirms that while most players finish close to expectation, a minority
          significantly over- or under-perform across multiple seasons.
        </p>
      </section>

    </div>
  );
};

export default Finishing;

